import React, { Component } from 'react';
import { showReferrals } from '../../../../../Actions/showReferralsAction'
import './ReferralsPage.css'
import ReferralsList from './ReferralsList';
import { connect } from 'react-redux'

import Loader from 'react-loader-spinner'
//firebase stuff
import firebase from 'firebase/app'
import { auth } from '../../../../../Config/Firebase';
import PageHeader from '../../PageHeader/PageHeader';
import InformationCards from '../../InformationCards/InformationCards';

let db = firebase.firestore();
let usersRef = db.collection("Users");

class ReferralsPage extends Component {
    state = {
        referrals_array: [],
        number_of_completed_referrals: 0,
        total_number_of_referrals: 0,
        search: "", 
        totalEarned: "$" + 0
    }

    componentWillMount() {

        const add_referral_to_state = [];

        auth.onAuthStateChanged((user) => {
            if (user) {
                //get firebase docs in realtime
                usersRef.doc(user.uid).collection("Referrals").onSnapshot(doc => { 
                    
                    //remove the existing divs with the classname referrals, this prevents the data being on the page twice
                    var existing_referrals_tr = document.getElementsByClassName("referrals");
                    while(existing_referrals_tr.length > 0){
                        existing_referrals_tr[0].parentNode.removeChild(existing_referrals_tr[0]);
                    }
                    //reset the totals
                    if(this.state.total_number_of_referrals !== 0){
                        this.setState({
                            number_of_completed_referrals: 0,
                            total_number_of_referrals : 0,
                            totalEarned: 0
                        })
                    }
                    
                    doc.forEach(doc => {
            
                        if(!doc.exists){
                            
                        } else {                          
                        
                            add_referral_to_state.push({
                                name: doc.id,
                                jobStatus: doc.data().Job_Status,
                                paidOut: doc.data().Pay_Out,
                                address: doc.data().address,
                                email: doc.data().email
                            })

                            //get the amount of referrals that are completed
                            if(doc.data().Job_Status === "Completed"){
                                
                                this.setState({
                                    number_of_completed_referrals: this.state.number_of_completed_referrals + 1,
                                    
                                })
                            }
                    
                            this.setState({
                                referrals_array: add_referral_to_state,
                                total_number_of_referrals: this.state.total_number_of_referrals + 1,
                                totalEarned: "$" + 200* this.state.number_of_completed_referrals
                            })     
                            
                        }      
                    })
                })
            }
        })
    }

//search box text 
search = () => {

    let searchBox = document.getElementById("searchInputBox");
    let searchValue = this.state.search;

    searchBox.addEventListener("keyup", function(){
    
        searchValue = this.value.toLowerCase();
       
        var existing_referrals_names = document.getElementsByClassName("referralName");
        var existing_referrals_tr= document.getElementsByClassName("referrals");
        
        for (var i = 0; i < existing_referrals_tr.length; i++) {
           console.log(!searchValue); console.log(searchValue);
                if (existing_referrals_names[i].textContent.toLowerCase().indexOf(searchValue) > -1 ){

                    existing_referrals_tr[i].style.opacity = "1";
                    existing_referrals_tr[i].style.position = "";
                    
                } else {
                    
                    existing_referrals_tr[i].style.opacity = "0";
                    existing_referrals_tr[i].style.position = "absolute";

                }
                    
            }
        })
    }
            

    
           
    render() { 
         
        if(this.props.email === null) {
            return (
                <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%", marginTop: "-50px", marginLeft: "-50px", width: "100px", height: "100px" }}>
                    <Loader 
                        type="TailSpin"
                        color="#001e61"
                        height="100"	
                        width="100"
                    /> 
                </div>
            )
        }

        return (      
            <div className="container referralsWrapper">

                    <div className="row">    
                        <div className="col-xl-12 greyBackground">
                            <PageHeader page="Referrals" showReferrals={this.props.showReferrals}/>

                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-4 no-padding">
                                        <InformationCards title="Number of Referrals" icon="fas fa-users" iconColor="#001e61" body={this.state.total_number_of_referrals} display="none" /> 
                                    </div>                   
                                    <div className="col-xl-4 no-padding">
                                        <InformationCards title="Completed Referrals" icon="fas fa-star" iconColor="#e28432" body={this.state.number_of_completed_referrals} display="none"/> 
                                    </div>                   
                                    <div className="col-xl-4 no-padding">
                                        <InformationCards title="Total Earned" icon="fas fa-dollar-sign" iconColor="#20a720" body={this.state.totalEarned}/>      
                                    </div>                   
                                </div>
                                
                            </div>

                        </div>

                        <div className="container">
                            <div className="referralsRowClass" id="referrals_row_id">
                            {
                                this.state.referrals_array.length === 0 ? 
                                <div className="text-center">
                                        <h2>You Have No Referrals</h2> 
                                    </div>
                                :
                                <table className="table" id="referralsTable">
                                <tbody>
                                    <tr>
                                        <th>Referral Name</th>
                                        <th>Paid Out</th>
                                        <th>Referral Address</th>
                                        <th>Referral Email</th>
                                        <th>Job Status</th>
                                    </tr>
                                    
                                    {
                                        //map the referrals from firebase to referral and pass the details as props
                                        this.state.referrals_array.map((referral,index) =>{
                                            return (
                                                <ReferralsList  
                                                referralName = {referral.name}
                                                referralStatus = {referral.jobStatus}
                                                referralPayout = {referral.paidOut}
                                                detailsBodyId = {referral.name + "body"}
                                                referralEmail = {referral.email}
                                                referralAddress = {referral.address}
                                                key={index}
                                                />
                                                
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            }
                        </div> 
                        </div>                   
                    </div>     

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        email : state.firebase.email
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

        showReferrals: () => dispatch(showReferrals(""))
        
  }
}

export default connect(mapStateToProps, mapDispatchToProps) (ReferralsPage);



// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/HavenReferrals/ReferralsPage/ReferralsPage.jsx